// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3-Vot","overflowing":"ReadFullNote_overflowing__2Wdiu"};